import { useState, useEffect, useCallback } from 'react';
import { fetchTeamKPIs, getTeamSummary } from '../services/kpiService';

/**
 * Custom hook for KPI data management
 */
export function useKPI(roleFilter = 'all') {
  const [teamMembers, setTeamMembers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Load KPI data
   */
  const loadKPIData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const [members, teamSummary] = await Promise.all([
        fetchTeamKPIs(roleFilter),
        getTeamSummary(roleFilter),
      ]);

      setTeamMembers(members);
      setSummary(teamSummary);
    } catch (err) {
      console.error('❌ Error loading KPI data:', err);
      setError(err.message || 'Failed to load KPI data');
    } finally {
      setLoading(false);
    }
  }, [roleFilter]);

  // Load data when filter changes
  useEffect(() => {
    loadKPIData();
  }, [loadKPIData]);

  return {
    teamMembers,
    summary,
    loading,
    error,
    reload: loadKPIData,
  };
}
